import { NavLink, Outlet } from "react-router-dom";
import { Wrench, LayoutDashboard, Boxes, ClipboardList, CalendarClock, FileCheck } from "lucide-react";

const TABS = [
  { to: "/maintenance",              label: "Dashboard",   icon: LayoutDashboard, end: true, testid: "mnt-tab-dashboard" },
  { to: "/maintenance/assets",       label: "Assets",      icon: Boxes,                     testid: "mnt-tab-assets" },
  { to: "/maintenance/work-orders",  label: "Work Orders", icon: ClipboardList,             testid: "mnt-tab-wos" },
  { to: "/maintenance/preventive",   label: "Preventive",  icon: CalendarClock,             testid: "mnt-tab-pm" },
  { to: "/maintenance/amcs",         label: "AMCs",        icon: FileCheck,                 testid: "mnt-tab-amcs" },
];

export default function MaintenanceShell() {
  return (
    <div className="space-y-6" data-testid="maintenance-shell">
      <div className="flex items-baseline gap-3">
        <div className="w-11 h-11 rounded-xl bg-hocp-gold flex items-center justify-center shrink-0">
          <Wrench className="w-5 h-5 text-hocp-eerie" strokeWidth={2}/>
        </div>
        <div>
          <h1 className="font-display text-[26px] font-bold text-hocp-navy leading-none">Maintenance OS</h1>
          <p className="text-[13px] text-slate-500 mt-1.5">Asset lifecycle · Work orders · Preventive maintenance · AMCs.</p>
        </div>
      </div>

      <div className="flex gap-1 border-b border-slate-200 overflow-x-auto">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-4 py-2.5 text-[13px] font-medium border-b-2 whitespace-nowrap transition-colors ${
                  isActive ? "border-hocp-navy text-hocp-navy" : "border-transparent text-slate-500 hover:text-slate-800"
                }`}>
              <Icon className="w-4 h-4" strokeWidth={1.75}/>{t.label}
            </NavLink>
          );
        })}
      </div>

      <Outlet />
    </div>
  );
}
